export enum FilterSectionName {
  Period = 1,
  CountryAndPerformance,
  Qualification,
  StructureSales,
  SortBy
}
